import { Controller } from "@hotwired/stimulus";
import { visit } from "@hotwired/turbo";
import { editAdminBillingContactPath } from "src/routes";

export default class extends Controller {
  static targets = ["modalFrame", "billingContactSelect", "editButton", "formError", "emailList", "emailTemplate"];

  declare modalFrameTarget: HTMLElement;
  declare billingContactSelectTarget: HTMLSelectElement;
  declare editButtonTarget: HTMLButtonElement;
  declare formErrorTarget: HTMLElement;
  declare emailListTarget: HTMLElement;
  declare emailTemplateTarget: HTMLTemplateElement;

  connect(): void {
    this.updateEditButton();
  }

  selectChanged(): void {
    this.updateEditButton();
  }

  closeModal(): void {
    this.modalFrameTarget.innerHTML = "";
  }

  editBillingContact(): void {
    const id = this.billingContactSelectTarget.value;
    if (!id) return;

    this.openModal(id);
  }

  newBillingContact(): void {
    this.openModal();
  }

  addEmail(): void {
    const clone = this.emailTemplateTarget.content.cloneNode(true);
    this.emailListTarget.appendChild(clone);
  }

  removeEmail(event: Event): void {
    (event.currentTarget as HTMLElement).closest(".field.has-addons")?.remove();
  }

  async submitForm(event: SubmitEvent): Promise<void> {
    /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    const response = await fetch(form.action, {
      method: form.method,
      body: new FormData(form),
      headers: { Accept: "application/json" },
    });

    if (response.ok) {
      const { id, label } = await response.json() as { id: number; label: string };
      const existing = this.billingContactSelectTarget.querySelector<HTMLOptionElement>(`option[value="${id}"]`);
      if (existing) {
        existing.text = label;
      } else {
        this.billingContactSelectTarget.add(new Option(label, id.toString(), true, true));
      }
      this.closeModal();
      this.updateEditButton();
    } else {
      const data = await response.json();
      this.formErrorTarget.innerText = (data.error as string);
      this.formErrorTarget.classList.remove("is-hidden");
    }
    /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
  }

  private openModal(billingContactId?: string): void {
    visit(
      editAdminBillingContactPath(billingContactId || "0"),
      { frame: this.modalFrameTarget.id }
    );
  }

  private updateEditButton(): void {
    this.editButtonTarget.disabled = !this.billingContactSelectTarget.value;
  }
}
